// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__aqeWQ","title":"style_title__HSbc0"};